const SelectArrowIcon = (props) => (
  <svg {...props} viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.00048 3.78132L8.30048 0.481323L9.24315 1.42399L5.00048 5.66666L0.757812 1.42399L1.70048 0.481323L5.00048 3.78132Z" fill={props.fill ?? "#616778"}/>
  </svg>
);

export default SelectArrowIcon;
